import { Box, Center } from '@chakra-ui/react'
import { useAccountContext } from '@src/components/sco/Account/Layout/AccountContext'
import { AccountMainPanel } from '@src/components/sco/Account/Layout/AccountMainPanel'
import { UserProfileForm } from '@src/components/sco/Account/UserProfileForm'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { AccountPage } from '@src/layouts/AccountPageLayout'
import React from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'
export default AccountPage(function () {
  const accountContext = useAccountContext()
  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('account.profile')
  })

  useUniversalEffect(() => {
    activeContent.setBreadcrumbs([
      {
        title: 'Account',
        href: '/account',
      },
      {
        title: 'Profile',
        href: '/account/profile',
      },
    ])
  }, [])

  return (
    <AccountMainPanel>
      <Center minHeight={'85vh'} padding={'1em'}>
        <Box maxWidth={'800px'} width={'full'}>
          <UserProfileForm showAdditionalFields={true} title={'Personal Profile'} />
        </Box>
      </Center>
    </AccountMainPanel>
  )
})
